import { css } from '@emotion/react'
import { Heading, Text, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { memo } from 'react'

type AtestadoContentBoxVariant = 'default' | 'modal'

interface AtestadoContentBoxProps {
  title: string
  content: string
  isContentRichText?: boolean
  variant?: AtestadoContentBoxVariant
}

export const AtestadoContentBox = memo((props: AtestadoContentBoxProps) => {
  const { title, content, isContentRichText = false, variant = 'default' } = props

  return (
    <Box>
      <VFlow vSpacing={1} style={styles[variant]}>
        <Heading level={3}>{title}</Heading>

        {isContentRichText ? <Text dangerouslySetInnerHTML={{ __html: content }} /> : <Text>{content}</Text>}
      </VFlow>
    </Box>
  )
})

const styles = {
  default: css`
    justify-content: center;
    align-items: center;
    margin: 1rem 6rem 2rem;
  `,
  modal: css`
    justify-content: center;
    align-items: center;
    margin: 1rem 1.75rem;
  `,
}
